import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/common/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ebcd9fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-search" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = ["placeholder"]

import { ref } from "vue";
import { useRouter } from "vue-router";
import {
  getNft,
  getTx,
  getBlockNumber,
  getTxsFromToUser,
  getTxDetailsFromToUser,
  getERC20,
  getERC1155,
} from "@/api/_common";
import t from "@/utils/en";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const content = ref("");

const search = () => {
  const isBlockNumber = /^[0-9]*$/gm;
  const isTransactionHash = /^0x([A-Fa-f0-9]{64})$/;
  const isAddressHash = /^0x([A-Fa-f0-9]{40})$/;
  if (isBlockNumber.test(content.value)) {
    getBlock(content.value);
  } else if (isTransactionHash.test(content.value)) {
    getTransaction(content.value);
  } else if (isAddressHash.test(content.value)) {
    // Get ERC-20, ERC-721 or ERC-1155 by contract address
    getInfoByAddress(content.value);
  } else {
    // Get NFT by contract name
    getNFT(content.value);
  }
};

const getBlock = async (blockNumber) => {
  const res = await getBlockNumber({
    Number: parseInt(blockNumber),
  });
  if (res.Time < 1 && blockNumber > 0) {
    localStorage.clear();
    router.push({
      name: "BlockCountdown",
      params: { Number: blockNumber },
    });
  } else if (res.Time > 1) {
    router.push({ name: "Block", params: { Number: blockNumber } });
  } else {
    ElMessage(t.message.searchfailed);
  }
};

const getTransaction = async (transactionHash) => {
  const res = await getTx({
    Hash: transactionHash,
  });
  if (res.Time < 1) {
    ElMessage(t.message.searchfailed);
  } else {
    router.push({ name: "Tx", params: { Hash: transactionHash } });
  }
};

const getInfoByAddress = async (value) => {
  const user = {
    User: value,
    PageNo: 1,
    PageNoSecondary: 1,
    PageSize: 10,
  };
  const txDetailsFromToUserParams = {
    User: value,
    PageNo: 0,
    PageSize: 10,
  };
  let res = await getNft({
    Contract: value,
  });
  if (res.Type === 1 || res.Type === 2 || res.Type === 3) {
    router.push({
      name: "ContractDetail",
      params: { Contract: value },
    });
  } else {
    res = await getTxsFromToUser(user);
    if (res.TotalCount > 0) {
      router.push({ name: "UserTxs", params: { ...user } });
    } else {
      res = await getTxDetailsFromToUser(txDetailsFromToUserParams);
      if (res.TotalCount > 0) {
        router.push({ name: "UserTxs", params: { ...user } });
      } else {
        ElMessage(t.message.searchfailed);
      }
    }
  }
};

const getNFT = async (name) => {
  const res = await getNft({
    Name: name,
  });
  if (res) {
    router.push({
      name: "ContractDetail",
      params: {
        Contract: res.Contract,
      },
    });
  } else {
    ElMessage(t.message.searchfailed);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
      placeholder: _ctx.$t('home.placeholder'),
      onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (search()), ["enter"]))
    }, null, 40, _hoisted_3), [
      [_vModelText, content.value]
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (search()))
    }, _toDisplayString(_ctx.$t("home.search")), 1)
  ]))
}
}

})